import commonEn from "./common.en";

const commonFr: Record<string, string> = {
  "merchant.ap.export.preliminaryStatus": "Provisoire",
  "merchant.ap.export.unknownStatus": "Inconnu",
  "merchant.ap.export.stockIncomplete": "Éléments incomplets : vérifiez la clôture, les quantités et la valorisation avant un paquet définitif.",
  "merchant.ap.export.moreHistory": "Plus d’historique",
  "merchant.ap.export.historyScanHint": "Continuez pour consulter l’historique antérieur.",
  "merchant.ap.export.recoveryPending": "Le statut est temporairement indisponible. La récupération sera réessayée automatiquement.",
  "merchant.ap.export.retryStatus": "Réessayer le statut",
  "merchant.ap.export.includeStock": "Inclure les quantités et la valorisation des stocks",
  "merchant.ap.export.stockHint": "Sélectionnez chaque entrepôt et une clôture acceptée. Les instantanés existants sont en lecture seule. Les stocks utilisent la période exacte de clôture et le fuseau du restaurant ; les dates fournisseurs ci-dessus sont inclusives.",
  "merchant.ap.export.provisional": "Autoriser un paquet explicitement provisoire",
  "merchant.ap.export.warehouse": "Entrepôt",
  "merchant.ap.export.close": "Clôture acceptée",
  "merchant.ap.export.select": "Sélectionner…",
  "merchant.ap.export.removeScope": "Retirer le périmètre",
  "merchant.ap.export.supplement": "Complément au paquet",
  "merchant.ap.export.original": "Paquet original",
  "merchant.ap.export.stockUnavailable": "Aucun instantané de valorisation correspondant. Créez les éléments de valorisation dans l’espace de stock.",
  "merchant.ap.export.stockCompleteness": "{status} · {count} périmètres déclarés. Les autres entrepôts sont exclus.",
  "merchant.ap.export.unmapped": "UNMAPPED : JSON/CSV neutre uniquement ; aucun plan de comptes configuré.",
  "merchant.ap.export.final": "Définitif",



  "merchant.uom.catalogUnavailable": "Le catalogue d’unités est indisponible.",
  "merchant.uom.conversionRequired": "Une conversion d’unité est requise.",
  "merchant.uom.baseProposal": "Utiliser {unit} comme unité de base pour {item} ?",
  "merchant.uom.confirmFailed": "Échec de la confirmation de l’unité de base.",
  "merchant.uom.confirm": "Confirmer",
  ...commonEn,
  "merchant.goods.close.decision.NO_VARIANCE": "Approuvé sans ajustement",
  "merchant.goods.close.decision.APPLY_ADJUSTMENT": "Approuvé avec ajustement du stock",
  "merchant.goods.close.additionalStock": "Effet supplémentaire de cette commande sur le stock",
  "merchant.goods.close.referenceReconciliation": "Le comptage initial reste figé. Les faits tardifs confirmés modifient le solde attendu ; seule la différence avec les effets déjà appliqués est comptabilisée.",
  "merchant.goods.close.blocker.CLOSED_BOUNDARY_EVIDENCE_REQUIRED": "Utilisez les limites exactes de l’ouverture approuvée et du comptage final normalisé.",
  "merchant.goods.close.blocker.CLOSE_REFERENCE_RECOUNT_REQUIRED": "La limite initiale ne contient pas le recomptage requis pour cette correction non nulle. Un nouveau comptage ne peut pas se substituer à cette limite.",
  "merchant.goods.close.blocker.SOURCE_ADMISSION_MISSING": "Certaines commandes concernées n’ont pas d’admission de source de stock prouvée.",
  "merchant.goods.close.blocker.SOURCE_COUNT_TIMING_AMBIGUOUS": "Des éléments tardifs chevauchent le comptage initial des matières ou préparations. La quantité à la limite est incertaine.",
  "merchant.goods.close.blocker.CLOSE_PARENT_ALLOCATION_EVIDENCE_MISSING": "La révision précédente ne contient pas d’éléments d’allocation immuables complets.",
  "merchant.goods.close.blocker.CLOSE_LATE_LOT_BOUNDARY_EVIDENCE_MISSING": "Un lot tardif n’était pas couvert par le comptage initial.",
  "merchant.goods.close.blocker.CLOSE_ORIGINAL_COUNT_BOUNDARY_INSUFFICIENT": "Les éléments initiaux de comptage des matières ou préparations sont incomplets.",
  "merchant.goods.close.blocker.CLOSE_APPROVED_REFERENCE_EVIDENCE_MISSING": "L’inventaire approuvé ne contient pas de référence reproductible à l’ajustement appliqué.",

  "merchant.goods.close.newPlan": "Créer un nouveau plan défini par les comptages",
  "merchant.goods.close.savedClosing": "Inventaire final figé de référence",
  "merchant.goods.close.linkedMode": "Révision liée : l’ouverture, le comptage final et l’intervalle d’origine restent fixés.",
  "merchant.goods.close.newMode": "Nouveau plan : choisissez son ouverture approuvée et son comptage final.",

  "merchant.goods.close.countDefined": "La couverture suit l’ouverture approuvée et le comptage de clôture sélectionné. Cet intervalle est défini par les comptages ; il n’établit pas un solde indépendant de fin de mois.",
  "merchant.goods.close.from": "Limite d’ouverture approuvée (incluse)",
  "merchant.goods.close.to": "Limite normalisée du comptage final (exclue)",

  "merchant.goods.close.openingEquivalent": "Équivalent brut initial",
  "merchant.goods.close.closingEquivalent": "Équivalent brut final",

  "merchant.goods.close.policy.savedRecipe": "Recette figée enregistrée",
  "merchant.goods.close.policy.refresh": "Actualiser les versions des règles",

  "merchant.goods.close.refresh": "Actualiser les dossiers enregistrés",
  "merchant.goods.close.savedOpening": "Ouverture approuvée enregistrée",
  "merchant.goods.close.error.stale": "Les éléments ont changé. Créez une révision liée avant de signer.",
  "merchant.goods.close.error.access": "Ce dossier ou cette configuration est indisponible avec vos autorisations actuelles.",
  "merchant.goods.close.error.conflict": "Le dossier ou la règle a changé. Actualisez et vérifiez la version actuelle.",
  "merchant.goods.close.error.input": "Vérifiez la période, les unités et les limites de la règle.",
  "merchant.goods.close.error.recipeOptionsBound": "Cet entrepôt comporte plus de 500 versions de recettes distinctes. Contactez l’assistance pour examiner le périmètre des recettes.",
  "merchant.goods.close.error.retry": "La requête n’a pas abouti. Vérifiez la connexion et réessayez ; la même commande de dossier peut être répétée sans doublon.",

  "merchant.goods.close.blocker.SOURCE_BOUND_EXCEEDED": "Les sources dépassent la taille de dossier prise en charge.",
  "merchant.goods.close.blocker.SOURCE_PENDING_OR_OPAQUE": "Certaines commandes sont en attente ou leur propriétaire est inconnu.",
  "merchant.goods.close.blocker.SOURCE_COVERAGE_UNKNOWN": "La couverture des commandes est incomplète.",
  "merchant.goods.close.blocker.SOURCE_OBSERVATION_UNRESOLVED": "Des éléments de commande contradictoires doivent être résolus.",
  "merchant.goods.close.blocker.SOURCE_OWNER_OR_IDENTITY_UNKNOWN": "Un composant de commande n’a pas de propriétaire ou d’identité établi.",
  "merchant.goods.close.blocker.SOURCE_COMPONENT_SCOPE_UNKNOWN": "Une commande ne peut pas être rattachée à un périmètre complet.",
  "merchant.goods.close.blocker.SOURCE_NOT_APPLIED": "Certains effets de stock confirmés ne sont pas entièrement appliqués.",
  "merchant.goods.close.blocker.SOURCE_OCCURRENCE_TIME_UNPROVEN": "La date réelle d’une modification de commande n’est pas établie pour cette période.",
  "merchant.goods.close.blocker.SOURCE_HISTORICAL_FACT_UNRESOLVED": "Des éléments historiques de commande restent non résolus.",
  "merchant.goods.close.blocker.FULL_COMPONENT_SCOPE_REQUIRED": "Un comptage complet de tous les composants est nécessaire.",
  "merchant.goods.close.blocker.CLOSE_APPROVAL_UNAVAILABLE": "L’approbation de clôture sélectionnée est indisponible.",
  "merchant.goods.close.blocker.CLOSE_BOUNDARY_EVIDENCE_MISSING": "Les éléments initiaux et finaux ne couvrent pas les limites de la période.",
  "merchant.goods.close.blocker.CLOSE_REVIEW_UNRESOLVED_OR_EXCLUDED": "Résolvez les décisions de contrôle, les exclusions et les horaires de comptage.",
  "merchant.goods.close.blocker.MOVEMENT_BOUND_EXCEEDED": "L’historique du stock dépasse la taille de dossier prise en charge.",
  "merchant.goods.close.blocker.UNPOSTED_DOCUMENTS": "Comptabilisez ou résolvez les documents de stock en attente.",
  "merchant.goods.close.blocker.POLICY_BOUND_EXCEEDED": "Trop de versions de règles pour un seul dossier.",
  "merchant.goods.close.blocker.RECIPE_BOUND_EXCEEDED": "Trop de versions figées de recettes pour un seul dossier.",
  "merchant.goods.close.blocker.CLOSE_UOM_CHANGED": "L’unité de base d’un ingrédient a changé depuis le comptage.",
  "merchant.goods.close.blocker.OPENING_APPROVAL_RECONCILIATION_MISSING": "L’ouverture approuvée ne contient pas de comptage rapproché complet.",
  "merchant.goods.close.blocker.LATE_OPENING_EVIDENCE_REQUIRES_CORRECTION": "Des éléments tardifs affectent l’ouverture approuvée ; créez une correction.",
  "merchant.goods.close.blocker.CLOSE_RESTAURANT_TIMEZONE_CHANGED": "Utilisez le fuseau horaire configuré du restaurant.",
  "merchant.goods.close.blocker.CLOSE_RESTAURANT_TIMEZONE_INVALID": "Corrigez d’abord le fuseau horaire du restaurant.",
  "merchant.goods.close.blocker.MOVEMENT_COMPONENT_SCOPE_UNKNOWN": "Certains mouvements de stock n’ont pas de composant compté.",
  "merchant.goods.close.blocker.MOVEMENT_CANONICAL_QUANTITY_MISSING": "Certains mouvements n’ont pas de quantité prouvée dans l’unité de base figée.",
  "merchant.goods.close.reason.INCOMPLETE_SCOPE": "Périmètre incomplet",
  "merchant.goods.close.reason.OPT_IN_REQUIRED": "Inférence non activée",
  "merchant.goods.close.reason.POLICY_INTERVAL": "Règle hors période",
  "merchant.goods.close.reason.COMPONENT_OR_DIMENSION": "Composants ou unités incompatibles",
  "merchant.goods.close.reason.INVALID_BOUNDS": "Limites de règle invalides",
  "merchant.goods.close.reason.DIRECTION": "Écarts incompatibles avec le sens autorisé",
  "merchant.goods.close.reason.RECIPE_AMBIGUOUS_OR_INELIGIBLE": "Recette ambiguë ou inadmissible",
  "merchant.goods.close.reason.QUANTITY_NOT_UNIQUE": "Aucune quantité exacte unique",
  "merchant.goods.close.reason.QUANTITY_OR_FRACTION_LIMIT": "Limite de quantité ou de fraction de recette dépassée",
  "merchant.goods.close.reason.UNKNOWN_COST": "Coût inconnu",
  "merchant.goods.close.reason.VALUE_LIMIT": "Limite de valeur dépassée",
  "merchant.goods.close.reason.COMPETING_ALTERNATIVES": "Alternatives admissibles concurrentes",
  "merchant.goods.close.state.DRAFT": "Brouillon",
  "merchant.goods.close.state.READY": "Prêt",
  "merchant.goods.close.state.APPROVAL": "En attente d’approbation",
  "merchant.goods.close.state.POSTED": "Comptabilisé",
  "merchant.goods.close.state.CANCELLED": "Annulé",

  "merchant.goods.close.automate": "Exécuter l’automatisation explicitement activée",

  "merchant.goods.close.policy.title": "Règles de substitution dirigées",
  "merchant.goods.close.policy.notice": "A → B uniquement ; aucune règle inverse implicite. Enregistrez une nouvelle version immuable pour activer ou désactiver l’inférence. L’automatisation exige les contrôles d’approbation et des coûts connus. Les dates exigent un décalage UTC explicite.",
  "merchant.goods.close.policy.versions": "Versions existantes (sélectionner pour créer la suivante)",
  "merchant.goods.close.policy.new": "Nouvelle règle",
  "merchant.goods.close.policy.active": "Inférence activée",
  "merchant.goods.close.policy.inactive": "Inférence désactivée",
  "merchant.goods.close.policy.key": "Nom de la règle",
  "merchant.goods.close.policy.fromGoodsItemId": "Ingrédient prévu A",
  "merchant.goods.close.policy.toGoodsItemId": "Remplacement B",
  "merchant.goods.close.policy.recipe": "Recette figée admissible",
  "merchant.goods.close.policy.ratioNumerator": "Numérateur du ratio (unités B)",
  "merchant.goods.close.policy.ratioDenominator": "Dénominateur du ratio (unités A)",
  "merchant.goods.close.policy.maxQuantity": "Quantité maximale de A",
  "merchant.goods.close.policy.maxFraction": "Fraction normative maximale (0–1)",
  "merchant.goods.close.policy.maxValue": "Valeur maximale (facultatif)",
  "merchant.goods.close.policy.effectiveFrom": "Début de validité (inclus)",
  "merchant.goods.close.policy.effectiveTo": "Fin de validité (exclue, facultatif)",
  "merchant.goods.close.policy.inference": "Activer explicitement l’inférence",
  "merchant.goods.close.policy.automation": "Autoriser l’automatisation limitée (contrôles d’approbation requis)",
  "merchant.goods.close.policy.save": "Enregistrer une version immuable",

  "merchant.goods.close.closing": "Inventaire de clôture",
  "merchant.goods.close.currentApproval": "Approbation actuellement sélectionnée",

  "merchant.goods.close.title": "Dossier de clôture de période",
  "merchant.goods.close.notice": "Le comptage prouve les quantités. Une inférence selon une règle reste distincte d’une confirmation physique. Le dossier comptabilise une seule fois l’ajustement net.",
  "merchant.goods.close.opening": "Inventaire initial approuvé",
  "merchant.goods.close.timezone": "Fuseau horaire du restaurant (IANA)",
  "merchant.goods.close.create": "Créer une révision liée / aperçu",
  "merchant.goods.close.revisions": "Révisions enregistrées",
  "merchant.goods.close.previous": "Révision précédente",
  "merchant.goods.close.blocked": "Obstacles à la complétude",
  "merchant.goods.close.component": "Composant",
  "merchant.goods.close.stock": "Variation du stock",
  "merchant.goods.close.consumption": "Attribution de consommation",
  "merchant.goods.close.classification": "Classification",
  "merchant.goods.close.alternatives": "Alternatives rejetées et versions des règles",
  "merchant.goods.close.POLICY_INFERRED": "Inféré selon la règle",
  "merchant.goods.close.PHYSICALLY_CONFIRMED": "Confirmé physiquement",
  "merchant.goods.close.UNEXPLAINED": "Inexpliqué",
  "merchant.goods.close.UNIQUE": "Unique",
  "merchant.goods.close.AMBIGUOUS": "Ambigu",
  "merchant.goods.close.action.DRAFT": "Marquer prêt",
  "merchant.goods.close.action.READY": "Demander l’approbation du responsable",
  "merchant.goods.close.action.APPROVAL": "Approuver et comptabiliser une fois",
  "merchant.goods.close.cancel": "Annuler la révision",
  "merchant.goods.close.explicitOffset": "Saisissez les dates avec Z ou un décalage UTC explicite.",
  "merchant.goods.review.compositionBridge": "Comparaison de référence de composition : le solde initial précédent reste figé. Elle ne modifie pas le stock et ne prouve aucune perte physique.",
  "merchant.goods.session.contentReference": "Référence du contenant / contenu distinct",
  "merchant.goods.session.physicalContentsOnce": "Comptez chaque contenu physique une seule fois : les matières premières et les préparations sont des objets distincts. La référence est votre déclaration, pas une reconnaissance automatique du contenu.",
  "publicContact.logoAlt": "Logo A3 Systems",
  "publicContact.call": "Appeler",
  "publicContact.email": "E-mail",
  "publicContact.website": "Site web",
  "publicContact.saveContact": "Enregistrer le contact",
  "waiter.tableDetail.header.backToTables": "← Tables",
  "waiter.tableDetail.header.guests": "Clients",
  "waiter.tableDetail.header.details": "Détails",
  "waiter.tableDetail.screen.add": "Ajouter",
  "waiter.tableDetail.screen.cart": "Panier",
  "waiter.tableDetail.screen.orders": "Commandes",
  "waiter.tableDetail.screen.requests": "Commandes / Demandes",
  "waiter.tableDetail.screen.more": "Plus",
  "waiter.tableDetail.add.search": "Rechercher",
  "waiter.tableDetail.add.searchAll": "Rechercher tous les plats",
  "waiter.tableDetail.help.title": "Un client demande de l'aide",
  "waiter.tableDetail.help.body": "Appeler le serveur",
  "waiter.tableDetail.help.requestedAt": "Appelé à {time}",
  "waiter.tableDetail.help.seen": "Vu",
  "waiter.tableDetail.reservation.title": "Réservation",
  "waiter.tableDetail.reservation.currentTable": "Cette table",
  "waiter.tableDetail.reservation.otherTables": "Autres tables",
  "waiter.tableDetail.reservation.cancel": "Annuler la réservation",
  "waiter.tableDetail.reservation.cancelShort": "Annuler",
  "waiter.tableDetail.reservation.cancelConfirmTitle": "Annuler la réservation ?",
  "waiter.tableDetail.reservation.cancelConfirmBody": "Cette réservation sera annulée pour le client.",
  "waiter.tableDetail.reservation.numberLabel": "Réservation",
  "waiter.tableDetail.reservation.tableDetailsLabel": "Table {table}",
  "waiter.tableDetail.reservation.cancelReasonLabel": "Motif d'annulation",
  "waiter.tableDetail.reservation.cancelReasonPlaceholder": "Choisir un motif",
  "waiter.tableDetail.reservation.cancelReasonRequiresText": "commentaire requis",
  "waiter.tableDetail.reservation.cancelReasonRequired": "Choisissez un motif d'annulation.",
  "waiter.tableDetail.reservation.canceled": "Réservation annulée.",
  "waiter.tableDetail.reservation.applyConfirmTitle": "Appliquer la réservation maintenant ?",
  "waiter.tableDetail.reservation.applyConfirmBody":
    "La réservation sera déplacée immédiatement vers cette table et l'horaire sera mis à jour.",
  "waiter.tableDetail.reservation.applyConfirmAction": "Appliquer la réservation",
  "waiter.tableDetail.reservation.syncPendingWarning":
    "Réservation appliquée localement, mais la synchronisation Restoplace doit être relancée.",
  "waiter.tableDetail.reservation.syncOverlapWarning":
    "Réservation appliquée localement, mais il y a un chevauchement avec une autre réservation dans Restoplace.",
  "waiter.tableDetail.occupy.now": "Occuper maintenant",
  "waiter.tableDetail.occupy.modalTitle": "Occuper la table",
  "waiter.tableDetail.occupy.confirmGuestPrompt": "Il y a une réservation active sur cette table. Est-ce votre client ?",
  "waiter.tableDetail.occupy.sameGuest": "Oui, même client",
  "waiter.tableDetail.occupy.differentGuest": "Non, autre client",
  "waiter.tableDetail.occupy.relocatePrompt":
    "Choisissez une table pour déplacer la réservation active, puis occupez cette table en walk-in.",
  "waiter.tableDetail.occupy.relocateTargetLabel": "Déplacer la réservation vers",
  "waiter.tableDetail.occupy.confirmRelocate": "Déplacer et occuper",
  "waiter.tableDetail.occupy.noActiveReservation":
    "Aucune réservation active trouvée. Occuper cette table comme walk-in maintenant ?",
  "waiter.tableDetail.occupy.success.noActive": "Table occupée en walk-in.",
  "waiter.tableDetail.occupy.success.matchExisting": "Réservation active mise à jour et table occupée.",
  "waiter.tableDetail.occupy.success.relocated": "Réservation déplacée vers une autre table et walk-in démarré.",
  "waiter.tableDetail.orders.openOrders": "Commandes ouvertes",
  "waiter.tableDetail.orders.newOrder": "Nouvelle commande",
  "waiter.tableDetail.orders.openedAt": "Ouvert {time}",
  "waiter.tableDetail.orders.openBill": "Note ouverte",
  "waiter.tableDetail.orders.paid": "Payé",
  "waiter.tableDetail.orders.remaining": "Reste",
  "waiter.tableDetail.orders.addGuestName": "Nom du client",
  "waiter.tableDetail.orders.locked": "Verrouillé",
  "waiter.tableDetail.queue.title": "File",
  "waiter.tableDetail.unsentCart.count": "Non envoyé au POS : {count} article(s)",
  "waiter.tableDetail.checkout.title": "Paiement",
  "waiter.tableDetail.checkout.statusPaid": "Payé",
  "waiter.tableDetail.checkout.statusPartiallyPaid": "Partiellement payé",
  "waiter.tableDetail.checkout.statusUnpaid": "Impayé",
  "waiter.tableDetail.checkout.addLanguageAge": "Ajouter langue / âge",
  "waiter.tableDetail.checkout.showQr": "Afficher QR",
  "waiter.tableDetail.checkout.printX": "Imprimer le check",
  "waiter.tableDetail.checkout.acceptCash": "Accepter espèces",
  "waiter.tableDetail.checkout.forceCloseDb.title": "Clôturer les commandes et libérer la table",
  "waiter.tableDetail.checkout.forceCloseDb.description":
    "Clôturer les commandes ouvertes de cette table, terminer la réservation active et libérer la table.",
  "waiter.tableDetail.checkout.forceCloseDb.warning":
    "Le POS n'est pas modifié. La libération dans Restoplace est tentée automatiquement.",
  "waiter.tableDetail.checkout.closeAllOpenOrders": "Clôturer les commandes et libérer la table",
  "waiter.tableDetail.checkout.forceCloseDb.confirm": "Clôturer et libérer",
  "waiter.tableDetail.checkout.forceCloseDb.closing": "Clôture…",
  "waiter.tableDetail.checkout.forceCloseDb.success": "{count} commande(s) locale(s) clôturée(s) et table libérée.",
  "waiter.tableDetail.checkout.forceCloseDb.empty": "Aucune commande locale ouverte restante. La libération de la table a quand même été tentée.",
  "waiter.tableDetail.checkout.forceCloseDb.error": "Échec de la clôture des commandes et de la libération de la table.",
  "waiter.tableDetail.action.add": "Ajouter",
  "waiter.tableDetail.action.addAll": "Tout ajouter",
  "waiter.tableDetail.action.reject": "Refuser",
  "waiter.tableDetail.action.rejectAll": "Tout refuser",
  "waiter.tableDetail.action.remove": "Retirer",
  "waiter.tableDetail.action.clear": "Effacer",
  "waiter.tableDetail.action.refresh": "Actualiser",
  "waiter.tableDetail.action.save": "Enregistrer",
  "waiter.tableDetail.action.back": "Retour",
  "waiter.tableDetail.action.cancel": "Annuler",
  "waiter.tableDetail.action.continue": "Continuer",
  "waiter.tableDetail.action.close": "Fermer",
  "waiter.tableDetail.common.loading": "Chargement…",
  "waiter.tableDetail.common.errorLabel": "Erreur:",
  "waiter.tableDetail.error.cancelReservation": "Impossible d'annuler la réservation",
  "waiter.tableDetail.error.loadOccupyPreview": "Impossible de charger l'aperçu d'occupation",
  "waiter.tableDetail.error.occupyTable": "Impossible d'occuper la table",
  "admin.aiModeration.generateDrafts.cta": "Generate AI Drafts",
  "admin.aiModeration.generateDrafts.running": "Generating…",
  "admin.aiModeration.generateDrafts.failed": "Failed to generate AI drafts",
  "admin.aiModeration.generateDrafts.generateOneCta": "Generate draft",
  "admin.aiModeration.generateDrafts.generateOneCompleted":
    "Draft generated: total={total}, persisted={persisted}, invalid={invalid}, failed={generationFailed}",
  "admin.aiModeration.generateDrafts.completed":
    "AI draft generation completed: total={total}, persisted={persisted}, invalid={invalid}, failed={generationFailed}",
  "admin.aiModeration.generateDrafts.summary":
    "Summary: total={total}, persisted={persisted}, invalid={invalid}, failed={generationFailed}",
  "admin.aiModeration.generateDrafts.regenerateOneCta": "Regenerate This Draft",
  "admin.aiModeration.generateDrafts.regenerateOneCompleted":
    "Draft regenerated: total={total}, persisted={persisted}, invalid={invalid}, failed={generationFailed}",
  "admin.aiModeration.generateDrafts.issuesTitle": "Items with validation/errors",
  "admin.aiModeration.generateDrafts.persistedWithValidationIssues": "Persisted with validation issues",
  "admin.aiModeration.queue.title": "AI moderation queue",
  "admin.aiModeration.queue.label": "Queue",
  "admin.aiModeration.queue.pending": "Pending",
  "admin.aiModeration.queue.aiGenerated": "AI generated",
  "admin.aiModeration.queue.approved": "Approved",
  "admin.aiModeration.queue.rejected": "Rejected",
  "admin.aiModeration.queue.all": "All",
  "admin.aiModeration.queue.refresh": "Refresh",
  "admin.aiModeration.queue.action": "Action",
  "admin.aiModeration.queue.review": "Review",
  "admin.aiModeration.queue.empty": "No AI profiles in this queue.",
  "admin.aiModeration.xlsx.exportCta": "Export AI XLSX",
  "admin.aiModeration.xlsx.importCta": "Import AI XLSX",
  "admin.aiModeration.xlsx.exported": "AI profiles XLSX exported",
  "admin.aiModeration.xlsx.exportFailed": "Failed to export AI profiles XLSX",
  "admin.aiModeration.xlsx.importFailed": "Failed to import AI profiles XLSX",
  "admin.aiModeration.modal.title": "AI profile moderation",
  "admin.aiModeration.modal.taxonomyRequired": "Canonical AI taxonomy (required for approval)",
  "admin.aiModeration.modal.canonicalCategoryKey": "Canonical category key",
  "admin.aiModeration.modal.selectCanonicalCategory": "Select canonical category",
  "admin.aiModeration.modal.canonicalTags": "Canonical tags",
  "admin.aiModeration.modal.canonicalTagsSearchPlaceholder": "Search canonical tags",
  "admin.aiModeration.modal.canonicalTagsEmpty": "No canonical tags selected yet.",
  "admin.aiModeration.modal.canonicalTagsNoResults": "No canonical tags match this search.",
  "admin.aiModeration.modal.rejectReason": "Reject reason (optional)",
  "admin.aiModeration.modal.rejectReasonPlaceholder": "Explain why AI draft is rejected",
  "admin.aiModeration.modal.cancel": "Cancel",
  "admin.aiModeration.modal.reject": "Reject",
  "admin.aiModeration.modal.approve": "Approve",
  "admin.aiModeration.modal.saveChanges": "Save changes",
  "admin.aiModeration.modal.suggestedFields": "Suggested fields",
  "admin.aiModeration.modal.suggestedFieldsEmpty": "Generate a draft to see AI suggestions for structured fields.",
  "admin.aiModeration.modal.useAiSuggestion": "Use AI suggestion",
  "admin.aiModeration.modal.useAllAiSuggestions": "Use all AI suggestions",
  "admin.aiModeration.modal.fieldColumn": "Field",
  "admin.aiModeration.modal.aiSuggestionColumn": "AI suggestion",
  "admin.aiModeration.modal.actionColumn": "Action",
  "admin.aiModeration.modal.auditTrail": "Audit trail",
  "admin.aiModeration.modal.auditEmpty": "No audit events yet.",
  "admin.aiModeration.modal.noProfileBadge": "No AI profile yet",
  "admin.aiModeration.modal.noProfileHelp": "Generate a draft to review AI classification for this item.",
  "admin.aiModeration.modal.draftHelp": "Review the draft, adjust taxonomy if needed, then approve or reject it.",
  "admin.aiModeration.modal.rejectedHelp": "This draft was rejected. Regenerate it or approve after manual correction.",
  "admin.aiModeration.modal.approvedHelp": "This item is approved. Adjust taxonomy values and save changes if needed.",
  "admin.aiModeration.modal.lastUpdated": "Last updated",
  "admin.aiModeration.modal.lastActor": "Last actor",
  "admin.aiModeration.modal.advanced": "Advanced",
  "admin.aiModeration.modal.aiProposed": "AI proposed",
  "admin.aiModeration.modal.approvedSnapshot": "Approved snapshot",
  "admin.aiModeration.modal.diff": "Diff: AI proposed vs approved",
  "admin.aiModeration.modal.approvedColumn": "Approved",
  "admin.aiModeration.opsTemplate.exportCta": "Export Ops Template",
  "admin.aiModeration.opsTemplate.importCta": "Import Ops XLSX",
  "admin.aiModeration.opsTemplate.exported": "Operational AI template exported",
  "admin.aiModeration.opsTemplate.exportFailed": "Failed to export operational AI template",
  "admin.aiModeration.opsTemplate.imported":
    "Operational AI import completed: created={created}, updated={updated}, unchanged={unchanged}",
  "admin.aiModeration.opsTemplate.importFailed": "Failed to import operational AI template",
  "admin.products.guestContent.title": "Guest-facing content",
  "admin.products.guestContent.nameEn": "Guest name EN",
  "admin.products.guestContent.nameLv": "Guest name LV",
  "admin.products.guestContent.nameRu": "Guest name RU",
  "admin.products.guestContent.nameFr": "Guest name FR",
  "admin.products.websiteDescription.title": "Website description",
  "admin.products.websiteDescription.help":
    "Shown on the merchant website and used as AI context when enrichment is enabled.",
  "admin.products.websiteDescription.en": "Website description EN",
  "admin.products.websiteDescription.lv": "Website description LV",
  "admin.products.websiteDescription.ru": "Website description RU",
  "admin.products.websiteDescription.fr": "Website description FR",
  "admin.products.websiteDescription.placeholder":
    "Write a factual storefront description: style, origin, aroma, taste, and serving context.",
  "admin.products.websiteDescription.approvedAiHint":
    "AI-approved products keep their current approved AI context until you regenerate and review a new draft manually.",
  "admin.products.descriptionState.empty": "Description empty",
  "admin.products.descriptionState.partial": "Description partial",
  "admin.products.descriptionState.complete": "Description complete",
  "admin.products.bulkDescriptions.copyToSelected": "Copy descriptions to selected ({count})",
  "admin.products.bulkDescriptions.copying": "Copying…",
  "admin.products.bulkDescriptions.copied": "Descriptions copied to {count} selected product(s)",
  "admin.products.bulkDescriptions.failed": "Failed to copy descriptions to selected products",
  "admin.products.bulkDescriptions.noTargets": "Select one or more other items to copy descriptions into.",
  "allergy.selector.label": "Allergies",
  "allergy.selector.hint": "Affiché sur les tickets cuisine et bar.",
  "allergy.gluten": "Céréales contenant du gluten",
  "merchant.staff.periodTitle": "Choisir la periode",
  "merchant.staff.periodBody": "Choisissez une periode rapide pour l'en-tete et la liste.",
  "merchant.staff.period.previous": "Periode precedente",
  "merchant.staff.period.next": "Periode suivante",
  "merchant.staff.period.today": "Aujourd'hui",
  "merchant.staff.period.yesterday": "Hier",
  "merchant.staff.period.tomorrow": "Demain",
  "merchant.staff.period.thisWeek": "Cette semaine",
  "merchant.staff.period.lastWeek": "Semaine derniere",
  "merchant.staff.period.nextWeek": "Semaine prochaine",
  "merchant.staff.period.thisMonth": "Ce mois-ci",
  "merchant.staff.period.lastMonth": "Mois dernier",
  "merchant.staff.period.nextMonth": "Mois prochain",
  "staff.portal.shiftSchedule": "Planning des services",
  "staff.portal.ready": "Pret",
  "staff.portal.schedule": "Planning",
  "staff.portal.teamMember": "Membre de l'equipe",
  "staff.portal.checkIn": "Arrivee",
  "staff.portal.checkOut": "Depart",
  "staff.portal.noShiftsAvailable": "Aucun service pour cette periode.",
  "staff.portal.shift.status.active": "En service",
  "staff.portal.shift.status.completed": "Termine",
  "staff.portal.shift.status.missed": "Manque",
  "staff.portal.shift.status.override": "Modifie",
  "staff.portal.shift.status.scheduled": "Planifie",
  "allergy.crustaceans": "Crustacés",
  "allergy.eggs": "Oeufs",
  "allergy.fish": "Poisson",
  "allergy.peanuts": "Arachides",
  "allergy.soybeans": "Soja",
  "allergy.milk": "Lait",
  "allergy.nuts": "Fruits à coque",
  "allergy.celery": "Céleri",
  "allergy.mustard": "Moutarde",
  "allergy.sesame": "Sésame",
  "allergy.sulphites": "Sulfites",
  "allergy.lupin": "Lupin",
  "allergy.molluscs": "Mollusques",
  "merchant.ap.view.reconciliation": "Rapprochement", "merchant.ap.reconciliation.loadError": "Impossible de charger la file de rapprochement.", "merchant.ap.reconciliation.permissionRequired": "L’autorisation de rapprochement est requise.", "merchant.ap.reconciliation.reason": "Motif de l’action", "merchant.ap.reconciliation.reasonRequired": "Saisissez un motif avant de continuer.", "merchant.ap.reconciliation.pendingApproval": "Envoyé à un autre utilisateur financier pour approbation.", "merchant.ap.reconciliation.applied": "Action de rapprochement appliquée.", "merchant.ap.reconciliation.actionError": "L’action n’a pas pu être appliquée. Actualisez et vérifiez les montants.", "merchant.ap.reconciliation.approvals": "En attente de contrôle", "merchant.ap.reconciliation.approve": "Approuver", "merchant.ap.reconciliation.reject": "Rejeter", "merchant.ap.reconciliation.empty": "Aucune opération bancaire à vérifier.", "merchant.ap.reconciliation.bankTransaction": "Opération bancaire", "merchant.ap.reconciliation.noCandidate": "Aucun paiement proposé trouvé", "merchant.ap.reconciliation.expected": "Attendu", "merchant.ap.reconciliation.booked": "Comptabilisé", "merchant.ap.reconciliation.confirm": "Confirmer", "merchant.ap.reconciliation.split": "Répartir", "merchant.ap.reconciliation.leave": "Laisser non rapproché", "merchant.ap.reconciliation.escalate": "Escalader", "merchant.ap.reconciliation.recentMatches": "Rapprochements manuels récents", "merchant.ap.reconciliation.reverse": "Annuler le rapprochement", "merchant.ap.reconciliation.counter.unmatchedBank": "Banque non rapprochée", "merchant.ap.reconciliation.counter.amountMismatch": "Écart de montant", "merchant.ap.reconciliation.counter.unknownPayment": "Paiement inconnu", "merchant.ap.reconciliation.counter.reversal": "Extourne", "merchant.ap.reconciliation.counter.supplierDispute": "Litige fournisseur", "merchant.ap.reconciliation.action.CONFIRM_MATCH": "Rapprochement confirmé", "merchant.ap.reconciliation.action.SPLIT_ALLOCATION": "Montant réparti", "merchant.ap.reconciliation.action.LEAVE_UNMATCHED": "Laissé non rapproché", "merchant.ap.reconciliation.action.ESCALATE": "Escaladé", "merchant.ap.reconciliation.action.REVERSE_MATCH": "Rapprochement annulé",
  "merchant.ap.reconciliation.allocationAmount": "Montant à répartir",
  "merchant.ap.reconciliation.loadMore": "Charger plus d’opérations",
  "merchant.ap.reconciliation.loadMoreMatches": "Charger les rapprochements antérieurs",
  "merchant.ap.reconciliation.entrySearch": "Rechercher une autre facture ouverte",
  "merchant.ap.reconciliation.search": "Rechercher",
  "merchant.ap.reconciliation.addEntry": "Ajouter",
  "merchant.ap.reconciliation.entrySearchError": "Impossible de charger les factures ouvertes.",
  "merchant.ap.reconciliation.loadMoreApprovals": "Charger plus d’approbations",
  "merchant.ap.reconciliation.escalationQueue": "Transmis pour examen complémentaire",
  "merchant.ap.reconciliation.loadMoreEscalations": "Charger les escalades précédentes",
  "merchant.ap.reconciliation.loadMoreInvoices": "Charger plus de factures",
  "loyalty.visitChanged": "Actualisez la page et ouvrez la visite en cours avant de modifier sa carte.",
  "loyalty.camera.starting": "Démarrage de la caméra…",
  "loyalty.camera.unsupported": "Ce navigateur ne permet pas le scan. Saisissez le numéro manuellement.",
  "loyalty.camera.permissionDenied": "Caméra indisponible. Vérifiez les autorisations ou saisissez le numéro manuellement.",
  "loyalty.camera.noCardFound": "Numéro de carte non reconnu.",
  "loyalty.camera.ambiguous": "Plusieurs numéros de carte détectés.",
  "loyalty.camera.selectCandidate": "Choisissez le bon numéro.",
  "merchant.ap.invalidAmount": "Saisissez un montant entier en unités monétaires mineures.",
  "merchant.dishes.menu.invalidPrice": "Le prix doit être un nombre positif ou nul.",
  "merchant.dishes.menu.invalidPreparationTime": "Le temps de préparation doit être un entier positif ou nul.",
  "merchant.dishes.menu.invalidTopPicks": "La quantité initiale doit être un entier positif ou nul.",
  "merchant.mobile.allContents": "Tous les contenus",
  "merchant.mobile.back": "Retour · conserver le brouillon",
  "merchant.mobile.closeSummary": "Résumé de clôture de période",
  "merchant.mobile.completeLocations": "Lieux saisis : {count}/{total}. Saisissez un zéro explicite pour un contenu absent.",
  "merchant.mobile.countTask": "Comptage physique",
  "merchant.mobile.coverageReady": "Aucun blocage de couverture signalé",
  "merchant.mobile.history": "Historique des versions",
  "merchant.mobile.loadError": "Chargement impossible. Actualisez et vérifiez votre accès.",
  "merchant.mobile.location": "Lieu de comptage",
  "merchant.mobile.name": "Nom",
  "merchant.mobile.newPreparation": "Nouvelle préparation",
  "merchant.mobile.nonSelling": "Une préparation est un calcul, sans Product vendu ni stock distinct.",
  "merchant.mobile.packageNotice": "Acceptez la totalité du dossier avec l’action ci-dessous. Les détails expliquent les quantités ; une substitution calculée ne prouve pas sa cause physique.",
  "merchant.mobile.physicalItem": "Objet physique",
  "merchant.mobile.physicalKind": "Contenu",
  "merchant.mobile.preparationTask": "Calcul de préparation",
  "merchant.mobile.preparations": "Préparations",
  "merchant.mobile.publish": "Publier une nouvelle version",
  "merchant.mobile.published": "Version publiée",
  "merchant.mobile.raw": "Matières premières",
  "merchant.mobile.readiness": "État de préparation",
  "merchant.mobile.recover": "Récupérer le brouillon",
  "merchant.mobile.remove": "Supprimer la ligne",
  "merchant.mobile.retainedRevision": "Version historique conservée",
  "merchant.mobile.staleRecipe": "La recette a changé. Actualisez et ouvrez explicitement sa dernière version avant publication.",
  "merchant.mobile.uncertainRecipe": "Le résultat de publication est inconnu. Actualisez les versions et vérifiez le résultat avant une autre publication.",
  "merchant.mobile.validation": "Vérifiez les quantités, unités et ingrédients obligatoires.",
  "merchant.mobile.value": "Coût consommé sur la période",
  "merchant.mobile.valueUnavailable": "Aucune valorisation enregistrée n’est disponible pour cette clôture.",
  "merchant.mobile.versionNotice": "Une nouvelle version s’applique aux calculs futurs. Les ventes passées, instantanés physiques et soldes initiaux gardent leur composition d’origine.",

  "merchant.mobile.draftUnavailable": "Le stockage du brouillon est indisponible. Autorisez le stockage avant publication.",

  "merchant.mobile.activeVersionUnits": "L’historique conserve ses unités figées. Une nouvelle version exige des unités de sortie et de matières premières actives ; choisissez explicitement leurs remplaçantes.",
  "merchant.mobile.selectActiveUnits": "Choisissez des unités actives avant de publier une nouvelle version.",
  "merchant.mobile.useCurrentConversion": "Utiliser la conversion actuelle",
  "merchant.mobile.numericPrecision": "Saisissez des valeurs exactes : 12 décimales pour les ingrédients et le rendement des préparations ; 4 pour le rendement des plats et les pertes. Les valeurs hors plage ne peuvent pas être publiées.",

  "merchant.valuation.loading": "Chargement de la valorisation enregistrée…",
  "merchant.valuation.AUTH": "Reconnectez-vous pour consulter la valorisation.",
  "merchant.valuation.ACCESS": "La valorisation est indisponible pour ce compte ou cette sélection.",
  "merchant.valuation.NETWORK": "Impossible de charger la valorisation. La clôture des quantités reste disponible.",
  "merchant.valuation.FINAL": "Coût consommé définitif",
  "merchant.valuation.PROVISIONAL": "Coût consommé provisoire",
  "merchant.valuation.UNKNOWN": "Les justificatifs de coût sont incomplets",
  "merchant.valuation.unknownAmount": "Montant inconnu",
  "merchant.valuation.minorUnits": "unités monétaires mineures",

};

export default commonFr;
